import React from 'react';
import { motion } from 'framer-motion';

export const ScrollingMarquee = () => {
  const items = [
    '12 · 24 · 52 WEEK PROGRAMS',
    'STRUCTURED TRAINING',
    'PRECISION NUTRITION',
    'WEEKLY ACCOUNTABILITY',
    'PROVEN RESULTS',
    'DIRECT COACHING',
    'BUILT FOR YOUR SCHEDULE'
  ];

  return (
    <section className="bg-dark py-12 md:py-16 overflow-hidden border-y border-gold/20 relative">
      <div className="relative">
        <motion.div
          className="flex whitespace-nowrap"
          animate={{
            x: [0, -1920]
          }}
          transition={{
            duration: 30,
            repeat: Infinity,
            ease: "linear"
          }}
        >
          {[...items, ...items, ...items].map((item, index) => (
            <div key={index} className="flex items-center mx-8">
              <span className="font-hero text-4xl md:text-6xl lg:text-7xl uppercase tracking-wider text-cream hover:text-gold transition-colors duration-500" style={{ fontWeight: 600 }}>
                {item}
              </span>
              <span className="text-gold text-4xl md:text-6xl lg:text-7xl mx-8">◆</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
